import { createFileRoute } from "@tanstack/react-router";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";
import { PageHeader } from "@/components/app/shell/page-header";
import { useFacility } from "@/lib/facility/facility";
import { useCan, useFeature } from "@/lib/policy";
import { guardRoute } from "@/lib/policy/route-guard";
import { VisitorKioskDepartmentsCard } from "./-components/kiosk/visitor-kiosk-departments-card";
import { VisitorKioskDevicesCard } from "./-components/kiosk/visitor-kiosk-devices-card";
import { VisitorKioskGraceCard } from "./-components/kiosk/visitor-kiosk-grace-card";
import { VisitorKioskHardwareCard } from "./-components/kiosk/visitor-kiosk-hardware-card";
import { VisitorKioskPrintersCard } from "./-components/kiosk/visitor-kiosk-printers-card";
import { VisitorKioskRecognitionCard } from "./-components/kiosk/visitor-kiosk-recognition-card";
import { VisitorKioskWatchlistCard } from "./-components/kiosk/visitor-kiosk-watchlist-card";

export const Route = createFileRoute("/_authenticated/_administration/settings/visitor-kiosk")({
  beforeLoad: ({ context }) => guardRoute(context.me, "visitor-kiosk"),
  component: VisitorKioskSettings,
});

/** The front door, one building at a time: each setting here belongs to exactly one building,
 *  so with every building chosen the screen asks for one first. */
function VisitorKioskSettings() {
  const { facilityId } = useFacility();
  const chosen = facilityId === "all" ? null : facilityId;
  const canManage = useCan("visitor:manage", chosen);
  const canSecure = useCan("visitor:security", chosen);
  const graceOn = useFeature("grace", chosen);

  return (
    <>
      <PageHeader
        title="Visitor kiosk"
        meta="Grace, the tablet at the door, the badge printer it prints to, the departments a visitor can be here for, and the names the desk wants a quiet word about."
      />
      {chosen === null ? (
        <OneBuildingCard prompt="Grace, kiosks, badge printers, departments and the watchlist each belong to one building. Choose the building to set up." />
      ) : (
        <>
          {graceOn ? <VisitorKioskGraceCard facilityId={chosen} canManage={canManage} /> : null}
          {graceOn ? (
            <VisitorKioskRecognitionCard
              facilityId={chosen}
              canManage={canManage}
              canSecure={canSecure}
            />
          ) : null}
          <VisitorKioskDevicesCard facilityId={chosen} canManage={canManage} />
          <VisitorKioskPrintersCard facilityId={chosen} canManage={canManage} />
          <VisitorKioskDepartmentsCard facilityId={chosen} canManage={canManage} />
          <VisitorKioskWatchlistCard facilityId={chosen} canManage={canManage} />
        </>
      )}
      <VisitorKioskHardwareCard />
    </>
  );
}
